import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";
import { savePostLoginRedirect } from "../lib/postLoginRedirect";

export default function ProtectedRoute({ children, requireCommand, requireExecutive, requireSheriff, requireHR, requireAgents, requireStudent, requireDetectiveBureau }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="auth-loading">
        <Loader2 className="h-8 w-8 animate-spin text-sheriff-gold" />
      </div>
    );
  }
  if (user === false) {
    savePostLoginRedirect(location.pathname + location.search + location.hash);
    return <Navigate to="/login" replace />;
  }
  // Google users MUST complete their IC profile (rp_name + discord_id) before
  // accessing any protected route. Bypass only for the completion page itself.
  if (user.google_auth && (!user.rp_name || !user.discord_id)) {
    return <Navigate to="/completa-profilo" replace />;
  }
  if (!user.is_approved) return <Navigate to="/login?pending=1" replace />;
  if (requireSheriff && user.role !== "Sceriffo") return <Navigate to="/dashboard?denied=1" replace />;
  if (requireExecutive && !user.is_executive) return <Navigate to="/dashboard?denied=1" replace />;
  if (requireCommand && !user.is_command) return <Navigate to="/dashboard?denied=1" replace />;
  if (requireHR && !user.perm_hr && !user.is_viewer) return <Navigate to="/dashboard?denied=1" replace />;
  if (requireAgents && !user.perm_agents) return <Navigate to="/dashboard?denied=1" replace />;
  if (requireDetectiveBureau && !user.perm_detective_bureau) return <Navigate to="/dashboard?denied=1" replace />;
  if (requireStudent && !user.is_student) return <Navigate to="/dashboard?denied=1" replace />;
  return children;
}
